import { h } from 'preact';
import { formatPrice } from '../utils/format-price';
import { t } from '../../theme/locales';
const GiftboxProduct = ({ handle , product , state , setState , isDiy  })=>{
    const safeHandle = String(handle).replace(/[^a-zA-Z0-9_-]/g, '-');
    const productInputId = `giftbox-product-${safeHandle}`;
    const title = product.title || handle;
    const isSelected = state.giftbox === handle;
    const variants = Array.isArray(product.variants) ? product.variants : [];
    const variantsWithId = variants.filter((variant)=>variant != null && variant.id != null);
    const availableVariants = variantsWithId.filter((variant)=>variant.available !== false);
    var _availableVariants_, _ref;
    const fallbackVariant = (_ref = (_availableVariants_ = availableVariants[0]) !== null && _availableVariants_ !== void 0 ? _availableVariants_ : variantsWithId[0]) !== null && _ref !== void 0 ? _ref : null;
    var _variantsWithId_find;
    const selectedVariant = isSelected ? (_variantsWithId_find = variantsWithId.find((variant)=>String(variant.id) === String(state.variant))) !== null && _variantsWithId_find !== void 0 ? _variantsWithId_find : fallbackVariant : fallbackVariant;
    const selectedVariantId = (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id) != null ? String(selectedVariant.id) : '';
    const description = (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.description) || product.description || '';
    var _selectedVariant_price, _ref1;
    const price = (_ref1 = (_selectedVariant_price = selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.price) !== null && _selectedVariant_price !== void 0 ? _selectedVariant_price : product.price) !== null && _ref1 !== void 0 ? _ref1 : null;
    const image = (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.smallImage) || (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.featuredImage) || product.smallImage || product.featuredImage;
    const variantSwatchLabel = t('gift_wrapping.color_swatches_label', 'Color:');
    return h('div', {
        key: handle,
        className: 'giftbox-product'
    }, [
        h('input', {
            id: productInputId,
            type: 'radio',
            name: 'giftbox',
            value: handle,
            className: 'giftbox-product__input',
            checked: isSelected,
            onInput: ()=>{
                return setState({
                    giftbox: handle,
                    variant: (fallbackVariant === null || fallbackVariant === void 0 ? void 0 : fallbackVariant.id) ? String(fallbackVariant.id) : '',
                    items: [],
                    isDiy
                });
            }
        }),
        h('label', {
            htmlFor: productInputId,
            className: 'giftbox-product__content'
        }, [
            h('div', {
                className: 'giftbox-product__image'
            }, [
                image ? h('img', {
                    src: image,
                    alt: product.featuredImageAlt || title || handle,
                    width: 60,
                    height: 64,
                    decoding: 'async'
                }) : null
            ]),
            h('div', {
                className: 'giftbox-product__details-container'
            }, [
                h('div', {
                    className: 'giftbox-product__details'
                }, [
                    h('div', {
                        className: 'giftbox-product__title'
                    }, title),
                    h('div', {
                        className: 'giftbox-product__price'
                    }, formatPrice(price))
                ]),
                h('div', {
                    className: 'giftbox-product__description'
                }, description),
                isSelected && variantsWithId.length > 1 ? h('fieldset', {
                    className: 'giftbox-product__variants'
                }, [
                    h('legend', {
                        className: 'giftbox-product__variants__legend'
                    }, [
                        h('span', {
                            className: 'giftbox-product__variants__legend-label'
                        }, variantSwatchLabel),
                        ' ',
                        h('span', {
                            className: 'giftbox-product__variants__legend-value'
                        }, (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.title) || '')
                    ]),
                    h('div', {
                        className: 'giftbox-product__variants__list',
                        role: 'radiogroup',
                        'aria-label': variantSwatchLabel
                    }, variantsWithId.map((variant)=>{
                        const variantId = String(variant.id);
                        const inputId = `giftbox-variant-${safeHandle}-${variantId}`;
                        const isChecked = variantId === String(selectedVariantId);
                        const isDisabled = variant.available === false;
                        return h('div', {
                            className: 'giftbox-product__variant',
                            key: inputId
                        }, [
                            h('input', {
                                id: inputId,
                                type: 'radio',
                                name: `giftbox-variant-${safeHandle}`,
                                value: variantId,
                                className: 'giftbox-product__variant-input',
                                checked: isChecked,
                                disabled: isDisabled,
                                onInput: ()=>setState({
                                        variant: variantId,
                                        items: []
                                    })
                            }),
                            h('label', {
                                htmlFor: inputId,
                                className: 'giftbox-product__variant-label',
                                title: variant.title || undefined,
                                style: variant.swatchImage ? `background-image:url('${variant.swatchImage}')` : undefined
                            }, h('span', {
                                className: 'u-vhide'
                            }, variant.title || ''))
                        ]);
                    }))
                ]) : null
            ])
        ])
    ]);
};
export { GiftboxProduct };
